import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { TenantStorageUsageView } from "./TenantStorageUsageView";
import { TenantStorageUsageViewStore } from "../../store/TenantStorageUsageViewStore";
import { useStore } from "../../../../hooks";

export const TenantStorageUsageViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/tenantStorageUsage/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new TenantStorageUsageViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <TenantStorageUsageView tenantStorageUsageViewStore={store} />
      </PageLayout>
    </div>
  );
});
